import { useState } from "react";
import { downloadInvoice, getMasterEscalationList } from "src/services/invoice-api";
import { invoiceActions } from "src/context/invoice-slice";
import { useDispatch } from "react-redux";
import { Button, Modal } from "src/components";
import { useToast } from "src/hooks/useToast";
import InvoiceEscalationAction from "./InvoiceEscalationAction";

const InvoiceApprovalDetails = ({
    row,
    setTotalRowCount,
    setLoading,
    resetPagination,
}: {
    row: any;
    setTotalRowCount: (count: number) => void;
    setLoading: (loading: boolean) => void;
    resetPagination: () => void;
}) => {
    const data = row?.original;
    const [invoiceAction, setInvoiceAction] = useState<string>("");
    const dispatch = useDispatch();
    const { toast } = useToast();

    const invoice = data;

    const renderRow = (label: string, value: React.ReactNode | (() => React.ReactNode)) => (
        <tr className="text-sm text-[#303030]">
            <td className="p-3 border border-[#E3E3E3] bg-[#f7f7f7] font-medium">{label}</td>
            <td className="p-3 border border-[#E3E3E3]">
                {typeof value === "function" ? value() : value ?? "-"}
            </td>
        </tr>
    );

    const fetchPendingInvoice = async () => {
        try {
            setLoading(true);
            let query = {
                page: 1,
                page_size: 10,
            }
            const response = await getMasterEscalationList(query);
            setTotalRowCount(response?.data?.total);
            dispatch(invoiceActions.setInvoiceMasterApprovalList(response?.data?.data));
            resetPagination();
        } catch (error) {
            console.error("Failed to fetch orders:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <section className="px-5 pb-5 border border-[#ccc] border-t-0 rounded-b-lg">
            <table className="w-full border-collapse">
                <tbody>
                    {renderRow("Invoice Number", invoice?.invoice_number)}
                    {renderRow("FUID", invoice?.fuid)}
                    {renderRow("Status", invoice?.status)}
                    {renderRow("Pharmacist code", invoice?.pharmacist_code)}
                    {renderRow("Escalated Date", invoice?.escalated_date
                        ? `${new Date(invoice.escalated_date).toLocaleDateString("en-GB", {
                            day: "numeric",
                            month: "long",
                            year: "numeric",
                        })}, ${new Date(invoice.escalated_date).toLocaleTimeString("en-GB", {
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                        })}`
                        : "-"
                    )}
                    {renderRow("Escalated By", invoice?.escalated_by)}

                    {renderRow("Entry Type", invoice?.entry_type)}

                    {renderRow("Link Type", invoice?.link_type)}
                    {renderRow("Remarks", invoice?.comments)}
                    {renderRow("Invoice", (
                        <Button onClick={() => {
                            if (!invoice?.fuid_path) {
                                toast({ description: "Invoice not found", variant: "destructive" });
                                return;
                            }
                            downloadInvoice(invoice?.fuid_path, 0).then((res: any) => {
                                if (res?.data?.success && res?.data?.data) {
                                    window.open(res?.data?.data, "_blank"); // Opens the link in a new tab
                                } else {
                                    console.error("Failed to download the invoice.");
                                }
                            });
                        }} className="text-black  bg-[#F1F1F1] hover:bg-[#f6f6f6] px-3 py-1 rounded text-sm">
                            Download
                        </Button>
                    ))}
                </tbody>
            </table>

            <footer className="mt-5 flex items-center justify-end gap-3">
                <Button
                    onClick={() => setInvoiceAction("reject")}
                    className="w-fit h-9 mt-0 font-normal border border-[#D0D0D0]  bg-[#F1F1F1] shadow-sm"
                >
                    Reject
                </Button>
                <Button
                    onClick={() => setInvoiceAction("accept")}
                    className="text-white bg-[#8051FF]"
                >
                    Accept
                </Button>
            </footer>
            <Modal isOpen={invoiceAction === "reject" || invoiceAction === "accept"} onCloseModal={() => setInvoiceAction("")} isHeader={false}>
                <InvoiceEscalationAction
                    onSuccess={() => {
                        setInvoiceAction("");
                        fetchPendingInvoice();
                    }}
                    action={invoiceAction}
                    onCloseModal={() => setInvoiceAction("")}
                    invoiceData={invoice}
                />
            </Modal>
        </section>
    );
};

export default InvoiceApprovalDetails;
